import { getKeysOfObject, } from "../ts/utilities/wsi4_interfaces";
import { isObject, isString, } from "../ts/utilities/wsi4_typeguards";
function flattenObject(obj) {
    const flattened = {};
    if (!isObject(obj)) {
        throw Error("Wrong type.");
    }
    getKeysOfObject(obj)
        .forEach(key => {
        if (isObject(obj[key])) {
            Object.assign(flattened, flattenObject(obj[key]));
        }
        else if (!isString(obj[key])) {
            throw Error("Wrong type.");
        }
        else {
            flattened[key] = obj[key];
        }
    });
    return flattened;
}
function toTranslations(t) {
    const toRecord = (m) => flattenObject(m);
    return {
        "en-US": toRecord(t["en-US"]),
        "en-GB": toRecord(t["en-US"]),
        "de-DE": toRecord(t["de-DE"]),
        "fr-FR": toRecord(t["fr-FR"]),
        "it-IT": toRecord(t["it-IT"]),
    };
}
const english = {
    global: {
        articleName: "Article name",
        assemblies: "Assemblies",
        back: "Back",
        cancel: "Cancel",
        delete: "Delete",
        disabled: "Disabled",
        edit: "Edit",
        materialWithGas: "Material",
        next: "Next",
        positiveNumberInvalid: "Please enter a value greater than 0",
        submit: "Submit",
        uncommittedChangesSolution: "To proceed commit your changes or revert them.",
        uncommittedChangesWarning: "There are uncommitted changes.",
        warning: "Warning",
    },
    articleAttributes: {
        allRotations: "Arbitrary angle",
        approxUnitPrice: "This is an approximate quote;  exact prices are calculated after selection and nesting.",
        articleExternalDrawingNumber: "Drawing number",
        articleExternalPartNumber: "Article part number",
        articleExternalRevisionNumber: "Revision",
        attachmentWarning: "Attachments required",
        attachments: "Attachments",
        bottomMechanicalDeburring: "Underside mechanical deburring",
        checkUnfoldingOrder: "Please ensure the unfolding is correct before ordering.",
        checkUnfoldingRequest: "Please ensure the unfolding is correct before inquiring.",
        chosenThreads: "Chosen threads",
        comment: "Comment",
        counterSinkingInvalid: "Please enter a value greater than or equal to 0",
        countersinking: "Number of countersinks",
        cuttingGas: "Non-oxidized edges",
        disassemble: "Disassemble assembly",
        doubleSidedMechanicalDeburring: "Double sided mechanical deburring",
        fileDialog: "Browse",
        filesTooBig: "{n} file(s) too big in size",
        fixedRotations: "Angle relative to rolling mills",
        flipSideUsage: "Use flip side for unfolding",
        forcePurchasedPart: "Force purchased part",
        forceSheetMetalPart: "Force sheet metal part",
        invalidMaterial: "The material is invalid for one or more selected parts",
        material: "Material",
        materialSelection: "Please choose material",
        materialSelectionInvalid: "Option invalid for selected sheet thickness(es)",
        materialThicknessMismatch: "Not available for chosen sheet thickness(es)",
        mechanicalGrinding: "Grinding",
        missingScalePrices: "Lot prices could not be computed.",
        multiplicityDisabled: "Defined by assembly",
        nameInvalid: "Please enter a name",
        noGrinding: "None",
        noSelection: "No selection",
        perUnit: "Per unit",
        reset: "Reset",
        rotationInvalid: "Please enter a value greater or equal to 0 and less than 180 degrees",
        selectDegrees: "Select degrees",
        sheetHasTestReport: "Test report implicitly added by another article",
        showInformation: "Additional information",
        slideGrinding: "Slide grinding",
        tapping: "Tapping",
        testReport: "Test report",
        thicknessDisabled: "Determined by 3D model",
        threading: "Number of threads",
        threadingInvalid: "Please enter a value greater than or equal to 0",
        uploadingFiles: "Uploading {n} files",
    },
    partCreation: {
        addHoleCutout: "Add drilling",
        addPart: "Add part",
        article: "Article",
        ccw: "Counterclockwise",
        circleCutout: "Circle cutout",
        circleRadius: "Circle radius",
        cornerRadius: "Corner radius",
        cornerRadiusInvalid: "Please enter a value greater than 0",
        cornerRadiusSmallerSize: "Please enter a value smaller than the minimum of the sides",
        depth: "Depth",
        element: "Element",
        flangeLength: "Flange length",
        flangeLengthInvalid: "Flange length too short. The minimal value for the current angle is",
        height: "Height",
        holeCutout: "Drilling",
        holeElementsOverlap: "Elements overlap",
        holeInputNumberWarning: "Invalid value",
        holeInsideOuterPolygon: "Drilling must be inside the outer polygon (Minimum distance is the material thickness)",
        holeSmallerOuterPolygon: "Drilling must be smaller than the outer polygon (Minimum distance is the material thickness)",
        innerAngle: "Inner angle",
        inputThicknessWarning: "Value less or equal to sheet thickness",
        maxSizeInvalid: "Largest possible sheet size exceeded. The largest possible sheet size is ",
        partCreation: "Create part",
        partCreationSelection: "Please select the part type you want to create:",
        rectangleCutout: "Rectangle cutout",
        segmentsIntersect: "Segments intersect",
        sheetMetalProfile: "Sheet metal profile",
        sheetMinAreaInvalid: "The smallest possible area is ",
        sizeInvalid: "Please enter a value greater than 0",
        validInnerAngleRange: "The inner angle has to lie inside the following intervals: ",
        width: "Width",
        xCoordinate: "X-Coordinate",
        yCoordinate: "Y-Coordinate",
    },
    technicalDrawings: {
        arrowNext: "Next Drawing",
        arrowPrevious: "Previous Drawing",
    },
    layeredDialog: {
        color: "Color",
        cuttingContour: "Cutting contour",
        emptyLayered: "This layer is empty",
        engravingContour: "Engraving",
        ignoreFile: "Ignore file",
        layerName: "Name of layer",
        layerSelection: "Select layers",
        layersSelected: "Layers selected",
        noCuttingSelected: "No cutting contour selected",
        notSelected: "Ignore",
        thicknessInvalid: "Thickness invalid",
    },
    quickActions: {
        changeGrinding: "Change grinding",
        changeFixedRotations: "Change grain direction",
        changeMaterial: "Change sheet material",
        changeMultiplicity: "Change quantity",
        changeTapping: "Change tapping",
        changeThickness: "Change sheet thickness",
        changedParts: "Applied to",
        deletionWarning: "Do you want to delete the following parts?",
        manufacturablePartExplanation: "Only editable for parts that can be manufactured",
        notChangeableInQuickActions: "No quick action for selected parts",
        quickActions: "Quick actions",
        singlePartExplanation: "Only editable for single parts",
        thicknessPartExplanation: "Only editable for single sheet metal part",
        unchangedParts: "Not applied to",
    },
    documentDialog: {
        discount: "All prices include {n}% discount",
        priceNotDetermined: "There are parts that cannot be manufactured or quoted automatically.",
        priceNotDeterminedForcing: "There are parts that either were forced to be sheet metal parts, or cannot be manufactured, or cannot be quoted automatically.",
        priceNotDeterminedHandling: "Either edit/delete those parts, or request the project.",
        pricesWithTaxes: "All prices include {n}% VAT",
        pricesWithoutTaxes: "All prices without VAT",
        project: "Project",
        request: "Send\nrequest",
        requestToolTip: "Inquire if project can be manufactured",
        requestToolTipDisabled: "Request not possible; all articles can be manufactured",
        requestWarning: "Project can only be requested; parts exist that are not manufacturable or where price couldn't be determined",
        save: "Save",
    },
    errorDialog: {
        dxfInvalid: "No valid part detected",
        error: "Error",
        errorHeader: "An error occurred",
        file: "File",
        fileError: "Import failed for the following file(s)",
        fileIgnored: "File ignored",
        fileInvalid: "Not a supported file format",
        scriptError: "Error in wsi4 script",
        unknownError: "Unknown error",
    },
    projectTable: {
        collapse: "Collapse",
        cyanGeometryColorExplanation: "Bend snippets",
        expand: "Expand",
        filterBy: "Filter by",
        greenGeometryColorExplanation: "Upper side",
        manufacturable: "Manufacturable",
        manufacturableWithWarning: "Warning",
        materialWithCuttingGas: "Material",
        multiplicity: "Quantity",
        noResults: "Your search did not match any parts",
        notManufacturable: "Incorrect",
        partState: "Status",
        price: "Price",
        purchasedPart: "Purchased part",
        redGeometryColorExplanation: "Problematic geometries",
        searchHits: "1 search hit | {n} search hits",
        sheetBendingPart: "Bending part",
        sheetCuttingPart: "Sheet metal part",
        sideUsed: "Unfolding shows the upper side",
        singleParts: "Single parts",
        technicalDrawings: "Technical drawings",
        thickness: "Sheet thickness",
        total: "Total",
        unitPrice: "Unit price",
    },
    readonlyView: {
        readdPart: "Readd part",
    },
    wizard: {
        articleNameExplanation: "For each article set a name for it that is used in the online shop.",
        close: "Close window",
        importArticle: "Import article",
        materialWithGasExplanation: "For each article set the material of which it should be manufactured.",
        multiplicityExplanation: "For each article select how often the article should be manufactured.",
        notChangeableInWizard: "Automatically determined for this article.",
        thicknessExplanation: "For each flat article select the sheet thickness.",
    },
    tube: {
        circular: "Circular",
        outerRadius: "Outer radius",
        profile: "Profile",
        rectangular: "Rectangular",
        rectangularDimensions: "Dimensions",
        tubeDimX: "Tube length",
        tubeDimXInvalid: "Please enter a value between {min} and {max}",
        tubeEntryDisabled: "Please create new tube to change this value.",
        tubeMaterialDisabled: "Not available for selected profile",
        tubeProfileType: "Profile type",
        tubeSpecification: "Specification",
        tubeSpecificationDisabled: "Not available for selected profile and material",
        userDefinedTube: "Tube",
    },
};
const german = {
    global: {
        articleName: "Artikelname",
        assemblies: "Baugruppen",
        back: "Zurück",
        cancel: "Abbrechen",
        delete: "Entfernen",
        disabled: "Deaktiviert",
        edit: "Bearbeiten",
        materialWithGas: "Material",
        next: "Weiter",
        positiveNumberInvalid: "Bitte tragen Sie einen Wert größer 0 ein",
        submit: "Anwenden",
        uncommittedChangesSolution: "Um fortzufahren, wenden Sie Ihre Änderungen an oder setzten Sie diese zurück.",
        uncommittedChangesWarning: "Es gibt nicht angewendete Änderungen.",
        warning: "Warnung",
    },
    articleAttributes: {
        allRotations: "Freie Winkellage",
        approxUnitPrice: "Dies ist ein ungefährer Preis; genaue Preisbestimmung erfolgt nach Auswahl und Verschachtelung.",
        articleExternalDrawingNumber: "Zeichnungsnummer",
        articleExternalPartNumber: "Artikelnummer",
        articleExternalRevisionNumber: "Revisionsstand",
        attachmentWarning: "Anhänge benötigt",
        attachments: "Anhänge",
        bottomMechanicalDeburring: "Unterseite Entgraten",
        checkUnfoldingOrder: "Bitte vor Bestellung die generierte Abwicklung überprüfen.",
        checkUnfoldingRequest: "Bitte vor Anfrage die generierte Abwicklung überprüfen.",
        chosenThreads: "Ausgewählte Gewinde",
        comment: "Kommentar",
        counterSinkingInvalid: "Bitte tragen Sie einen Wert größer oder gleich 0 ein",
        countersinking: "Anzahl von Senkungen",
        cuttingGas: "Oxidfreie Kanten",
        disassemble: "Baugruppe auflösen",
        doubleSidedMechanicalDeburring: "Beidseitig Entgraten",
        fileDialog: "Durchsuchen",
        filesTooBig: "{n} Datei(en) zu groß",
        fixedRotations: "Winkellage zur Walzrichtung",
        flipSideUsage: "Blechunterseite für Abwicklung verwenden",
        forcePurchasedPart: "Zukaufteil erzwingen",
        forceSheetMetalPart: "Blechteil erzwingen",
        invalidMaterial: "Das Material ist ungültig für ein oder mehrere ausgewählte Teile",
        material: "Material",
        materialSelection: "Bitte wählen Sie ein Material aus",
        materialSelectionInvalid: "Option nicht valide für ausgewählte Blechdicke(n)",
        materialThicknessMismatch: "Für ausgewählte Blechdicke(n) nicht verfügbar",
        mechanicalGrinding: "Schleifen",
        missingScalePrices: "Staffelpreise konnten nicht berechnet werden.",
        multiplicityDisabled: "Durch Baugruppe festgelegt",
        nameInvalid: "Bitte tragen Sie einen Namen ein",
        noGrinding: "Ohne",
        noSelection: "Keine Auswahl",
        perUnit: "pro Stück",
        reset: "Zurücksetzen",
        rotationInvalid: "Bitte tragen Sie einen Wert größer gleich 0 und kleiner als 180 Grad ein",
        selectDegrees: "Winkellage auswählen",
        sheetHasTestReport: "Werkszeugnis implizit durch anderen Artikel hinzugefügt",
        showInformation: "Weitere Informationen",
        slideGrinding: "Gleitschleifen",
        tapping: "Gewindebohren",
        testReport: "Werkszeugnis",
        thicknessDisabled: "Durch 3D Modell bestimmt",
        threading: "Anzahl von Gewinden",
        threadingInvalid: "Bitte tragen Sie einen Wert größer oder gleich 0 ein",
        uploadingFiles: "Es werden {n} Dateien hochgeladen",
    },
    partCreation: {
        addHoleCutout: "Bohrung hinzufügen",
        addPart: "Teil hinzufügen",
        article: "Artikel",
        ccw: "Gegen den Uhrzeigersinn",
        circleCutout: "Kreiszuschnitt",
        circleRadius: "Kreisradius",
        cornerRadius: "Eckenradius",
        cornerRadiusInvalid: "Bitte tragen Sie einen Wert größer 0 ein",
        cornerRadiusSmallerSize: "Bitte tragen Sie einen Wert kleiner als das Minimum der Seiten ein",
        depth: "Tiefe",
        element: "Schenkel",
        flangeLength: "Schenkellänge",
        flangeLengthInvalid: "Schenkellänge zu kurz. Mindestwert für Winkel beträgt",
        height: "Höhe",
        holeCutout: "Bohrung",
        holeElementsOverlap: "Elemente überschneiden sich",
        holeInputNumberWarning: "Wert ungültig",
        holeInsideOuterPolygon: "Die Bohrung muss innerhalb des äußeren Polygons liegen (Mindestabstand entspricht der Materialdicke)",
        holeSmallerOuterPolygon: "Die Bohrung muss kleiner als das äußere Polygon sein (Mindestabstand entspricht der Materialdicke)",
        innerAngle: "Innener Winkel",
        inputThicknessWarning: "Wert kleiner gleich Blechdicke",
        maxSizeInvalid: "Maximale Blechgröße überschritten. Die maximale Blechgröße beträgt ",
        partCreation: "Bauteil erstellen",
        partCreationSelection: "Bitte wählen Sie den Bauteiltyp aus, den Sie erstellen möchten:",
        rectangleCutout: "Rechteckszuschnitt",
        segmentsIntersect: "Segmente schneiden sich.",
        sheetMetalProfile: "Blechprofil",
        sheetMinAreaInvalid: "Die minimale Fläche beträgt ",
        sizeInvalid: "Bitte tragen Sie einen Wert größer 0 ein",
        validInnerAngleRange: "Der innere Winkel muss zwischen innerhalb der folgenden Intervalle liegen: ",
        width: "Breite",
        xCoordinate: "X-Koordinate",
        yCoordinate: "Y-Koordinate",
    },
    technicalDrawings: {
        arrowNext: "Naechste Zeichnung",
        arrowPrevious: "Vorherige Zeichnung",
    },
    layeredDialog: {
        color: "Farbe",
        cuttingContour: "Schneid­kontur",
        emptyLayered: "Diese Ebene ist leer",
        engravingContour: "Gravur",
        ignoreFile: "Datei ignorieren",
        layerName: "Name der Ebene",
        layerSelection: "Ebenen auswählen",
        layersSelected: "Ebenen ausgewählt",
        noCuttingSelected: "Keine Schneidkontur selektiert",
        notSelected: "Ignorieren",
        thicknessInvalid: "Dicke ungültig",
    },
    quickActions: {
        changeGrinding: "Schleifen ändern",
        changeFixedRotations: "Winkellage ändern",
        changeMaterial: "Blechmaterial ändern",
        changeMultiplicity: "Bestellmenge ändern",
        changeTapping: "Gewindebohren ändern",
        changeThickness: "Blechdicke ändern",
        changedParts: "Angewendet auf",
        deletionWarning: "Wollen Sie die folgenden Teile löschen?",
        manufacturablePartExplanation: "Kann nur für fertigbare Teile eingestellt werden",
        notChangeableInQuickActions: "Keine Schnellaktion für ausgewählte Teile",
        quickActions: "Schnelle Aktionen",
        singlePartExplanation: "Kann nur für Einzelteile eingestellt werden",
        thicknessPartExplanation: "Kann nur für Einzelteil-Blechzuschnitte eingestellt werden",
        unchangedParts: "Nicht angewendet auf",
    },
    documentDialog: {
        discount: "Alle Preise inklusive {n}% Rabatt",
        priceNotDetermined: "Es existieren Teile, die entweder nicht produzierbar sind oder deren Preis nicht bestimmt werden konnte.",
        priceNotDeterminedForcing: "Es existieren Teile, die entweder als Blechteile erzwungen wurden, die nicht produzierbar sind oder deren Preis nicht bestimmt werden konnte.",
        priceNotDeterminedHandling: "Entweder bearbeiten/löschen Sie diese Teile, oder Sie fragen das Projekt an.",
        pricesWithTaxes: "Alle Preise inklusive {n}% Mehrwertsteuer",
        pricesWithoutTaxes: "Alle Preise exklusive Mehrwertsteuer",
        project: "Projekt",
        request: "Anfragen",
        requestToolTip: "Produzierbarkeit des Projekts anfragen",
        requestToolTipDisabled: "Anfragen ist deaktiviert, da alle Teile produzierbar sind",
        requestWarning: "Dieses Projekt kann nur angefragt werden; Teile existieren, die nicht produzierbar sind oder deren Preis nicht bestimmbar ist",
        save: "Speichern",
    },
    errorDialog: {
        dxfInvalid: "Es wurde kein gültiges Teil erkannt",
        error: "Fehler",
        errorHeader: "Ein Fehler ist aufgetreten",
        file: "Datei",
        fileError: "Die folgenden Dateien konnten nicht importiert werden",
        fileIgnored: "Datei wird ignoriert",
        fileInvalid: "Format nicht unterstützt",
        scriptError: "Fehler in wsi4 Skript",
        unknownError: "Unbekannter Fehler",
    },
    projectTable: {
        collapse: "Verkleinern",
        cyanGeometryColorExplanation: "Biegezonen",
        expand: "Vergrößern",
        filterBy: "Filter nach",
        greenGeometryColorExplanation: "Gefertigte Oberseite",
        manufacturable: "Produzierbar",
        manufacturableWithWarning: "Warnung",
        materialWithCuttingGas: "Material",
        multiplicity: "Bestellmenge",
        noResults: "Keine Ergebnisse zur Suchanfrage gefunden",
        notManufacturable: "Fehlerhaft",
        partState: "Status",
        price: "Preis",
        purchasedPart: "Zukaufteil",
        redGeometryColorExplanation: "Problematische Geometrien",
        searchHits: "{n} Suchtreffer",
        sheetBendingPart: "Biegeteil",
        sheetCuttingPart: "Blechzuschnitt",
        sideUsed: "Abwicklung zeigt gefertigte Oberseite",
        singleParts: "Einzelteile",
        technicalDrawings: "Technische Zeichnungen",
        thickness: "Blechdicke",
        total: "Gesamt",
        unitPrice: "Stückpreis",
    },
    readonlyView: {
        readdPart: "Teil wieder hinzufügen",
    },
    wizard: {
        articleNameExplanation: "Bitte vergeben Sie hier für jeden Artikel einen Namen, unter dem dieser Artikel im Online-Shop geführt werden soll.",
        close: "Schließe Fenster",
        importArticle: "Artikel importieren",
        materialWithGasExplanation: "Bitte wählen Sie für jeden Artikel das Material aus, aus dem der Artikel gefertigt werden soll.",
        multiplicityExplanation: "Bitte geben Sie für jeden Artikel an, wie oft er bestellt werden soll.",
        notChangeableInWizard: "Für diesen Artikel wurde der Wert automatisch bestimmt.",
        thicknessExplanation: "Bitte wählen Sie für jeden flachen Artikel die Blechdicke aus, aus dem er gefertigt werden soll.",
    },
    tube: {
        circular: "Kreisförmig",
        profile: "Profil",
        outerRadius: "Außenradius",
        rectangular: "Rechteckig",
        rectangularDimensions: "Maße",
        tubeDimX: "Rohrlänge",
        tubeDimXInvalid: "Bitte geben Sie einen Wert zwischen {min} und {max} ein",
        tubeEntryDisabled: "Zum Ändern legen Sie bitte ein neues Rohr an.",
        tubeMaterialDisabled: "Für ausgewähltes Profil nicht verfügbar",
        tubeProfileType: "Profiltyp",
        tubeSpecification: "Spezifikation",
        tubeSpecificationDisabled: "Für ausgewähltes Profil und Material nicht verfügbar",
        userDefinedTube: "Rohrzuschnitt",
    },
};
const french = {
    global: {
        articleName: "Nom de l'article",
        assemblies: "Assemblages",
        back: "Back",
        cancel: "Annuler",
        delete: "Supprimer",
        disabled: "Désactivé",
        edit: "Modifier",
        materialWithGas: "Matériau",
        next: "Next",
        positiveNumberInvalid: "Veuillez inscrire un valeur supérieur à 0",
        submit: "Soumettre",
        uncommittedChangesSolution: "To proceed commit your changes or revert them.",
        uncommittedChangesWarning: "There are uncommitted changes.",
        warning: "Warning",
    },
    articleAttributes: {
        allRotations: "Angle arbitraire",
        approxUnitPrice: "Ceci est un prix approximatif; les prix exacts sont calculés après votre sélection et l'imbrication",
        articleExternalDrawingNumber: "Drawing number",
        articleExternalPartNumber: "Article part number",
        articleExternalRevisionNumber: "Revision",
        attachmentWarning: "Attachments required",
        attachments: "Accessoires",
        bottomMechanicalDeburring: "Underside mechanical deburring",
        checkUnfoldingOrder: "Please ensure the unfolding is correct before ordering.",
        checkUnfoldingRequest: "Please ensure the unfolding is correct before inquiring.",
        chosenThreads: "Chosen threads",
        comment: "Commentaire",
        counterSinkingInvalid: "Please enter a value greater than or equal to 0",
        countersinking: "Nombre de chanfreins",
        cuttingGas: "Bords sans oxyde",
        disassemble: "Démonter",
        doubleSidedMechanicalDeburring: "Double sided mechanical deburring",
        fileDialog: "Parcourir",
        filesTooBig: "{n} fichiers trop gros",
        fixedRotations: "L'angle par rapport à la direction du laminage",
        flipSideUsage: "Utiliser le verso",
        forcePurchasedPart: "Force purchased part",
        forceSheetMetalPart: "Force sheet metal part",
        invalidMaterial: "Le matériau sélectionné est non disponible pour un ou plusieurs des pièces sélectioné(es)",
        material: "Matériau",
        materialSelection: "Veuillez sélectionner un matériau",
        materialSelectionInvalid: "Votre choix est invalide pour le matériau et l'épaisseur sélectionnés",
        materialThicknessMismatch: "Non disponible pour l'épaisseur sélectionnée",
        mechanicalGrinding: "Brossage/Ebavurage",
        missingScalePrices: "Prix du lot non calculable",
        multiplicityDisabled: "Déterminé par l'assemblage",
        nameInvalid: "Veuillez inscrire un nom",
        noGrinding: "Néant",
        noSelection: "No selection",
        perUnit: "unitaire",
        reset: "Réinitialiser",
        rotationInvalid: "Rotation invalide",
        selectDegrees: "Veuillez choisir un angle",
        sheetHasTestReport: "Test report implicitly added by another article",
        showInformation: "Additional information",
        slideGrinding: "Slide grinding",
        tapping: "Taraudages",
        testReport: "Certificat de contrôle",
        thicknessDisabled: "Déterminé par modèle 3D",
        threading: "Nombre de fraisages",
        threadingInvalid: "Please enter a value greater than or equal to 0",
        uploadingFiles: "Fichiers {n} en cours de téléchargement",
    },
    partCreation: {
        addHoleCutout: "Add drilling",
        addPart: "Add part",
        article: "Article",
        ccw: "Counterclockwise",
        circleCutout: "Circle cutout",
        circleRadius: "Circle radius",
        cornerRadius: "Corner radius",
        cornerRadiusInvalid: "Please enter a value greater than or equal to 0",
        cornerRadiusSmallerSize: "Please enter a value smaller than the minimum of the sides",
        depth: "Depth",
        element: "Element",
        flangeLength: "Flange length",
        flangeLengthInvalid: "Flange length too short. The minimal value for the current angle is",
        height: "Height",
        holeCutout: "Drilling",
        holeElementsOverlap: "Elements overlap",
        holeInputNumberWarning: "Invalid value",
        holeInsideOuterPolygon: "Drilling must be inside the outer polygon (Minimum distance is the material thickness)",
        holeSmallerOuterPolygon: "Drilling must be smaller than the outer polygon (Minimum distance is the material thickness)",
        innerAngle: "Inner angle",
        inputThicknessWarning: "Value less or equal to sheet thickness",
        maxSizeInvalid: "Largest possible sheet size exceeded. The largest possible sheet size is ",
        partCreation: "Create part",
        partCreationSelection: "Please select the part type you want to create:",
        rectangleCutout: "Rectangle cutout",
        segmentsIntersect: "Segments intersect",
        sheetMetalProfile: "Sheet metal profile",
        sheetMinAreaInvalid: "The smallest possible area is ",
        sizeInvalid: "Please enter a value greater than 0",
        validInnerAngleRange: "The inner angle has to lie inside the following intervals: ",
        width: "Width",
        xCoordinate: "X-Coordinate",
        yCoordinate: "Y-Coordinate",
    },
    technicalDrawings: {
        arrowNext: "Next Drawing",
        arrowPrevious: "Previous Drawing",
    },
    layeredDialog: {
        color: "Color",
        cuttingContour: "Cutting contour",
        emptyLayered: "This layer is empty",
        engravingContour: "Engraving",
        ignoreFile: "Ignore file",
        layerName: "Name of layer",
        layerSelection: "Select layers",
        layersSelected: "Layers selected",
        noCuttingSelected: "No cutting contour selected",
        notSelected: "Ignore",
        thicknessInvalid: "Thickness invalid",
    },
    quickActions: {
        changeGrinding: "Change grinding",
        changeFixedRotations: "Change angle",
        changeMaterial: "Change sheet material",
        changeMultiplicity: "Changer la quantité",
        changeTapping: "Change tapping",
        changeThickness: "Change sheet thickness",
        changedParts: "Applied to",
        deletionWarning: "Do you want to delete the following parts?",
        manufacturablePartExplanation: "Only editable for parts that can be manufactured",
        notChangeableInQuickActions: "No quick action for selected parts",
        quickActions: "Actions rapides",
        singlePartExplanation: "Only editable for single parts",
        thicknessPartExplanation: "Only editable for single sheet metal part",
        unchangedParts: "Not applied to",
    },
    documentDialog: {
        discount: "Prix incluant TVA de {n}%",
        priceNotDetermined: "There are parts that cannot be manufactured or quoted automatically.",
        priceNotDeterminedForcing: "There are parts that either were forced to be sheet metal parts, or cannot be manufactured, or cannot be quoted automatically.",
        priceNotDeterminedHandling: "Either edit/delete those parts, or request the project.",
        pricesWithTaxes: "All prices include {n}% VAT",
        pricesWithoutTaxes: "All prices without VAT",
        project: "Projet",
        request: "Demande",
        requestToolTip: "Demander si le projet est fabriquable",
        requestToolTipDisabled: "Demande pas possible; tous pièces sont fabriquables",
        requestWarning: "Project can only be requested; parts exist that are not manufacturable or where price couldn't be determined",
        save: "Enregistrer",
    },
    errorDialog: {
        dxfInvalid: "Aucune pièce valide détectée",
        error: "Error",
        errorHeader: "Une erreur s'est produite",
        file: "File",
        fileError: "Import failed for the following file(s)",
        fileIgnored: "File ignored",
        fileInvalid: "Format de fichier non pris en charge",
        scriptError: "Erreur de script",
        unknownError: "Erreur inconnue",
    },
    projectTable: {
        collapse: "Collapse",
        cyanGeometryColorExplanation: "Bend snippets",
        expand: "Expand",
        filterBy: "Filtrer par",
        greenGeometryColorExplanation: "Upper side",
        manufacturable: "Fabriquable",
        manufacturableWithWarning: "Warning",
        materialWithCuttingGas: "Matériau",
        multiplicity: "Quantité",
        noResults: "Votre recherche ne correspond à aucune pièce",
        notManufacturable: "Incorrect",
        partState: "État",
        price: "Prix",
        purchasedPart: "Pièce achetée",
        redGeometryColorExplanation: "Problematic geometries",
        searchHits: "{n} résultat(s) de recherche",
        sheetBendingPart: "Bending part",
        sheetCuttingPart: "Sheet metal part",
        sideUsed: "Mise à plat affiche la face supérieure",
        singleParts: "Pièces individuelles",
        technicalDrawings: "Technical drawings",
        thickness: "Épaisseur",
        total: "Total",
        unitPrice: "Prix unitaire",
    },
    readonlyView: {
        readdPart: "Readd part",
    },
    wizard: {
        articleNameExplanation: "For each article set a name for it that is used in the online shop.",
        close: "Close window",
        importArticle: "Import article",
        materialWithGasExplanation: "For each article set the material of which it should be manufactured.",
        multiplicityExplanation: "For each article select how often the article should be manufactured.",
        notChangeableInWizard: "Automatically determined for this article.",
        thicknessExplanation: "For each flat article select the sheet thickness.",
    },
    tube: {
        circular: "Circular",
        outerRadius: "Outer radius",
        profile: "Profile",
        rectangular: "Rectangular",
        rectangularDimensions: "Dimensions",
        tubeDimX: "Tube length",
        tubeDimXInvalid: "Please enter a value between {min} and {max}",
        tubeEntryDisabled: "Please create new tube to change this value.",
        tubeMaterialDisabled: "Not available for selected profile",
        tubeProfileType: "Profile type",
        tubeSpecification: "Specification",
        tubeSpecificationDisabled: "Not available for selected profile and material",
        userDefinedTube: "Tube",
    },
};
const italian = {
    global: {
        articleName: "Nome articolo",
        assemblies: "Assiemi",
        back: "Indietro",
        cancel: "Interrompi",
        delete: "Cancellare",
        disabled: "Disabilitato",
        edit: "Modificare",
        materialWithGas: "Materiale",
        next: "Continua",
        positiveNumberInvalid: "Prego inserire un valore maggiore di 0",
        submit: "Applica",
        uncommittedChangesSolution: "To proceed commit your changes or revert them.",
        uncommittedChangesWarning: "There are uncommitted changes.",
        warning: "Warning",
    },
    articleAttributes: {
        allRotations: "Rotazione libera",
        approxUnitPrice: "Si tratta di un prezzo indicativo; il calcolo preciso avviene dopo la tua scelta attraverso nesting.",
        articleExternalDrawingNumber: "Drawing number",
        articleExternalPartNumber: "Article part number",
        articleExternalRevisionNumber: "Revision",
        attachmentWarning: "Allegati richiesti",
        attachments: "Allegati",
        bottomMechanicalDeburring: "Underside mechanical deburring",
        checkUnfoldingOrder: "Please ensure the unfolding is correct before ordering.",
        checkUnfoldingRequest: "Please ensure the unfolding is correct before inquiring.",
        chosenThreads: "Chosen threads",
        comment: "Commento",
        counterSinkingInvalid: "Prego inserire un valore maggiore o uguale a 0",
        countersinking: "Numero di svasature",
        cuttingGas: "Bordi privi di ossidi",
        disassemble: "Dividere l'assieme",
        doubleSidedMechanicalDeburring: "Double sided mechanical deburring",
        fileDialog: "Cerca",
        filesTooBig: "{n} file troppo grandi",
        fixedRotations: "Angolo rispetto al senso di laminazione",
        flipSideUsage: "Utilizzare la parte inferiore per lo sviluppo",
        forcePurchasedPart: "Force purchased part",
        forceSheetMetalPart: "Force sheet metal part",
        invalidMaterial: "Materiale non valido per una o più icone",
        material: "Materiale",
        materialSelection: "Selezionare un materiale",
        materialSelectionInvalid: "Opzione non valida per spessore selezionato",
        materialThicknessMismatch: "Non disponibile per spessore selezionato",
        mechanicalGrinding: "Grinding",
        missingScalePrices: "Non è stato possibile calcolare prezzi a scaglioni.",
        multiplicityDisabled: "Determinato dell'assieme",
        nameInvalid: "Prego inserire un nome",
        noGrinding: "Senza",
        noSelection: "Nessuna scelta",
        perUnit: "al pezzo",
        reset: "Resettare",
        rotationInvalid: "Inserire un valore maggiore o uguale a 0, e minore di 180 gradi",
        selectDegrees: "Selezionare angolo",
        sheetHasTestReport: "Test report implicitly added by another article",
        showInformation: "Ulteriori informazioni",
        slideGrinding: "Burattatura",
        tapping: "Tapping",
        testReport: "Certificato",
        thicknessDisabled: "Determinato dal modello 3D",
        threading: "Numero filetti",
        threadingInvalid: "Inserire un valore maggiore o uguale a 0",
        uploadingFiles: "{n} file in fase di caricamento",
    },
    partCreation: {
        addHoleCutout: "Add drilling",
        addPart: "Aggiungere icona",
        article: "Articolo",
        ccw: "Antiorario",
        circleCutout: "Cerchio",
        circleRadius: "Raggio",
        cornerRadius: "Raggio dell'angolo",
        cornerRadiusInvalid: "Prego inserire un valore maggiore di 0",
        cornerRadiusSmallerSize: "Prego inserire un valore inferiore al minimo dei lati",
        depth: "Profondità",
        element: "Lato",
        flangeLength: "Lunghezza lato",
        flangeLengthInvalid: "Lunghezza del lato troppo corta. Il valore minimo è",
        height: "Altezza",
        holeCutout: "Drilling",
        holeElementsOverlap: "Elements overlap",
        holeInputNumberWarning: "Invalid value",
        holeInsideOuterPolygon: "Drilling must be inside the outer polygon (Minimum distance is the material thickness)",
        holeSmallerOuterPolygon: "Drilling must be smaller than the outer polygon (Minimum distance is the material thickness)",
        innerAngle: "Angolo interno",
        inputThicknessWarning: "Value less or equal to sheet thickness",
        maxSizeInvalid: "Superato misure massime della lamiera. Le dimensioni massime sono ",
        partCreation: "Creare icona",
        partCreationSelection: "Selezionare il tipo del pezzo da creare:",
        rectangleCutout: "Rettangolo",
        segmentsIntersect: "Segmenti sovrapposizionati.",
        sheetMetalProfile: "Profilo lamiera",
        sheetMinAreaInvalid: "L'area minima è ",
        sizeInvalid: "Inserire un valore maggiore di 0",
        validInnerAngleRange: "L'angolo interno deve essere tra i seguenti intervalli: ",
        width: "Larghezza",
        xCoordinate: "X-Coordinate",
        yCoordinate: "Y-Coordinate",
    },
    technicalDrawings: {
        arrowNext: "Disegno succesivo",
        arrowPrevious: "Disegno precedente",
    },
    layeredDialog: {
        color: "Color",
        cuttingContour: "Cutting contour",
        emptyLayered: "This layer is empty",
        engravingContour: "Engraving",
        ignoreFile: "Ignore file",
        layerName: "Name of layer",
        layerSelection: "Select layers",
        layersSelected: "Layers selected",
        noCuttingSelected: "No cutting contour selected",
        notSelected: "Ignore",
        thicknessInvalid: "Thickness invalid",
    },
    quickActions: {
        changeGrinding: "Change grinding",
        changeFixedRotations: "Modificare senso rotazione",
        changeMaterial: "Modificare materiale",
        changeMultiplicity: "Modificare quantità",
        changeTapping: "Change tapping",
        changeThickness: "Modificare spessore",
        changedParts: "Applied to",
        deletionWarning: "Sicuro di voler eliminare le seguenti icona?",
        manufacturablePartExplanation: "Only editable for parts that can be manufactured",
        notChangeableInQuickActions: "No quick action for selected parts",
        quickActions: "Azioni rapide",
        singlePartExplanation: "Only editable for single parts",
        thicknessPartExplanation: "Only editable for single sheet metal part",
        unchangedParts: "Not applied to",
    },
    documentDialog: {
        discount: "All prices include {n}% discount",
        priceNotDetermined: "Esistono icone, che non sono producibili o non èra possibile calcolare il prezzo.",
        priceNotDeterminedForcing: "There are parts that either were forced to be sheet metal parts, or cannot be manufactured, or cannot be quoted automatically.",
        priceNotDeterminedHandling: "Modificare o cancellare le icona o fare una richiesta del progetto.",
        pricesWithTaxes: "Prezzi IVA {n}% inclusa",
        pricesWithoutTaxes: "Prezzi IVA esclusa",
        project: "Progetto",
        request: "Richiesta",
        requestToolTip: "Richiedere producibilità del progetto",
        requestToolTipDisabled: "Richiesta disattivata, perchè tutte le icone sono producibili",
        requestWarning: "Questo progetto deve essere richiesto; Esistono icone, che non sono producibili o non è possibile calcolare il prezzo",
        save: "Salva",
    },
    errorDialog: {
        dxfInvalid: "Non riconosciuto nessun icona",
        error: "Errore",
        errorHeader: "Si è verificato un errore",
        file: "File",
        fileError: "Import failed for the following file(s)",
        fileIgnored: "File ignored",
        fileInvalid: "Formato non supportato",
        scriptError: "Errore nel script WSi4",
        unknownError: "Errore non definito",
    },
    projectTable: {
        collapse: "Collapse",
        cyanGeometryColorExplanation: "Bend snippets",
        expand: "Expand",
        filterBy: "Filtra per",
        greenGeometryColorExplanation: "Upper side",
        manufacturable: "Producibile",
        manufacturableWithWarning: "Avviso",
        materialWithCuttingGas: "Materiale",
        multiplicity: "Quantità",
        noResults: "Nessun risultato di ricerca",
        notManufacturable: "Errato",
        partState: "Stato",
        price: "Prezzo",
        purchasedPart: "elemento d'acquisto",
        redGeometryColorExplanation: "Problematic geometries",
        searchHits: "{n} risultati di ricerca",
        sheetBendingPart: "Pezzo di piegatura",
        sheetCuttingPart: "Pezzo taglio laser",
        sideUsed: "Sviluppo mostra la superficie superiore",
        singleParts: "Icone singole",
        technicalDrawings: "Disegno tecnico",
        thickness: "Spessore",
        total: "Totale",
        unitPrice: "Prezzo unitario",
    },
    readonlyView: {
        readdPart: "Aggiungere nuovamente l'icona",
    },
    wizard: {
        articleNameExplanation: "For each article set a name for it that is used in the online shop.",
        close: "Close window",
        importArticle: "Import article",
        materialWithGasExplanation: "For each article set the material of which it should be manufactured.",
        multiplicityExplanation: "For each article select how often the article should be manufactured.",
        notChangeableInWizard: "Automatically determined for this article.",
        thicknessExplanation: "For each flat article select the sheet thickness.",
    },
    tube: {
        circular: "Circolare",
        outerRadius: "Raggio esterno",
        profile: "Profile",
        rectangular: "Rettangolare",
        rectangularDimensions: "Misure",
        tubeDimX: "Lunghezza tubo",
        tubeDimXInvalid: "Inserire un valore tra {min} e {max}",
        tubeEntryDisabled: "Crea un nuovo tubo per modificare.",
        tubeMaterialDisabled: "Non disponibile per il profilo selezionato",
        tubeProfileType: "Tipo di profilo",
        tubeSpecification: "Specifica",
        tubeSpecificationDisabled: "Non disponibile per il profilo ed il materiale selezionato",
        userDefinedTube: "Taglio tubo",
    },
};
const internalTranslations = toTranslations({
    "en-US": english,
    "en-GB": english,
    "de-DE": german,
    "fr-FR": french,
    "it-IT": italian,
});
export function isSupportedLocale(s) {
    const keys = {
        "en-US": null,
        "en-GB": null,
        "de-DE": null,
        "fr-FR": null,
        "it-IT": null,
    };
    return getKeysOfObject(keys)
        .some(k => k === s);
}
export const translations = (() => internalTranslations)();
